'use client'

import { useState, useEffect, useCallback } from 'react'

export function useThemeMode(defaultTheme: 'light' | 'dark' | 'system' = 'system') {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (defaultTheme === 'dark') return true
    if (defaultTheme === 'light') return false
    return false // Will be updated in useEffect for 'system'
  })

  useEffect(() => {
    if (typeof window === 'undefined') return

    if (defaultTheme === 'system') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      setIsDarkMode(mediaQuery.matches)

      const handler = (e: MediaQueryListEvent) => setIsDarkMode(e.matches)
      mediaQuery.addEventListener('change', handler)
      return () => mediaQuery.removeEventListener('change', handler)
    }
  }, [defaultTheme])

  const toggleTheme = useCallback(() => {
    setIsDarkMode(prev => !prev)
  }, [])

  return { isDarkMode, setIsDarkMode, toggleTheme }
}
